<template>
  <transition name="fade">
  <div v-if="isVisible" class="options-overlay cursor-pointer" @click="expand" @mouseover="clearHideTimer" @mouseout="hide">
    <div class="options">
      <icon v-show="displayAnnotate" type="post" class="option post" @annotate="annotate"></icon>
      <div class="middlerow">
        <icon v-if="canPreview" type="expand" class="option expand" @expand="expand"></icon>
      </div>
      <icon v-if="canAnnotate" type="comment" class="option comment" @annotate="annotate"></icon>
    </div>
  </div>
  </transition>
</template>

<script>
import Icon from './Icon'
import auth from '@/mixins/auth'

export default {
  components: {
    Icon
  },

  props: ['show', 'canAnnotate', 'canPreview', 'canCreate', 'canEdit', 'project', 'post', 'isLocked'],
  mixins: [auth],
  data: function () {
    return {
      hideTimer: null
    }
  },

  computed: {
    displayAnnotate: function () {
      return (this.isAdmin || this.projectRole === 'anonAdmin' || (this.isProjectEditable && !this.isProjectSubmitted)) && (this.canCreate && this.canAnnotate && this.isPostEditable)
    },
    isProjectSubmitted: function () {
      return this.project.submitted
    },
    isProjectEditable: function () {
      return this.project.isEditable
    },
    isPostEditable: function () {
      return this.post.postFeatures.canEdit
    },
    isVisible: function () {
      return this.show && (this.canAnnotate || this.canPreview)
    },
    canEditSubmission: function () {
      return this.isAdmin || this.projectRole === 'anonAdmin' || (this.isProjectEditable && !this.isProjectSubmitted && this.canEdit && this.isPostEditable)
    }
  },

  methods: {
    clearHideTimer: function () {
      if (this.hideTimer !== null) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
    },
    hide: function () {
      if (this.hideTimer === null) {
        this.hideTimer = setTimeout(() => { this.$emit('hide') }, 250)
      }
    },
    annotate: function (option) {
      this.$emit('annotate', option)
    },
    expand: function () {
      this.$emit('expand')
    },
    edit: function () {
      this.$emit('edit')
    },
    deleting: function () {
      this.$emit('deleting')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.options-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: rgba(0,0,0,.3);
  z-index: 3;

  .options {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    z-index: 3;

    .middlerow {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin: auto;
    }

    .option {
      display: flex;
      flex-direction: row;

      &.post {
        justify-content: flex-start;
        margin: 1rem 0 0 1rem;
      }

      &.comment {
        justify-content: flex-end;
        margin: 0 1rem 1rem 0;
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>
